export default __webpack_public_path__ + "64b59ae8256c487b11cf167c6beb043e.png";